<template>
  <div class="home-footer-info">
    <div class="statistics-chart-body">
      <div class="statistics-chart">
        <div class="home-title">
          <p>场景统计</p>
        </div>
        <div>
          <div id="echarts" style="width: 100%; height: 360px"></div>
        </div>
      </div>
      <div class="home-footer-feedback">
        <div class="home-title">
          <p>问题反馈</p>
        </div>
        <div class="feedback-body">
          <div>
            <a-input
              type="text"
              placeholder="请填写问题标题"
              v-model="createFeedbackData.questionTitle"
            />
            <a-textarea
              placeholder="请描述您要反馈的问题，我们将尽快给您回复"
              v-model="createFeedbackData.questionContent"
            />
            <a-button class="btn-green" @click="submitFeedback">提交</a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createFeedback } from "@/api/interactive";
import { mapGetters } from "vuex";
import { getTimeStatistic } from "@/api/common";
export default {
  data() {
    return {
      createFeedbackData: {
        questionTitle: "",
        questionContent: "",
      },
    };
  },
  computed: mapGetters(["userInfo"]),
  mounted() {
    this.myEcharts();
  },
  methods: {
    submitFeedback() {
      let data = this.createFeedbackData;
      if (!this.userInfo) {
        this.$message.warning("请登录后再提交！");
        return;
      }
      if (!data.questionTitle) {
        this.$message.warning("请填写反馈标题");
        return;
      }
      if (!data.questionContent) {
        this.$message.warning("请描反馈内容");
        return;
      }
      createFeedback(data).then((res) => {
        this.$message.success("提交成功，请到用户中心我的互动中查看！");
        this.createFeedbackData = {
          questionTitle: "",
          questionContent: "",
        };
      });
    },
    myEcharts() {
      getTimeStatistic().then((res) => {
        const times = res.data.map((e) => e.text);
        const scenes = res.data.map((e) => e.sceneCount);
        const activitys = res.data.map((e) => e.activityCount);
        const achvs = res.data.map((e) => e.achvCount);
        const reviews = res.data.map((e) => e.reviewCount);
        var myChart = this.$echarts.init(document.getElementById("echarts"));
        var option = {
          tooltip: {
            trigger: "axis",
          },
          color: ["#8B4CFF", "#FFA842", "#1FD3AF", "#2A75FF"],
          legend: {
            orient: "horizontal",
            right: "20px",
            top: "20px",
          },
          grid: {
            top: 60,
            left: 40,
            right: 30,
            bottom: 40,
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: false,
              data: times,
              axisTick: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  type: "solid",
                  color: "#bbb",
                },
              },
            },
          ],
          yAxis: [
            {
              type: "value",
            },
          ],
          series: [
            {
              symbol: "none",
              name: "场景",
              type: "line",
              smooth: true,
              data: scenes,
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(139, 76, 255, 0.08)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#ffffff", // 100% 处的颜色
                    },
                  ],
                },
              },
            },
            {
              symbol: "none",
              name: "榜单",
              type: "line",
              smooth: true,
              data: reviews,
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(255, 168, 66, 0.08)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#ffffff", // 100% 处的颜色
                    },
                  ],
                },
              },
            },
            {
              symbol: "none",
              name: "活动",
              type: "line",
              smooth: true,
              data: activitys,
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(31, 211, 175, 0.08)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#ffffff", // 100% 处的颜色
                    },
                  ],
                },
              },
            },
            {
              symbol: "none",
              name: "成果",
              type: "line",
              smooth: true,
              data: achvs,
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(42, 117, 255, 0.08)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#ffffff", // 100% 处的颜色
                    },
                  ],
                },
              },
            },
          ],
        };
        myChart.setOption(option);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  > p {
    font-size: 24px;
    line-height: 24px;
    padding-left: 12px;
    border-left: 4px solid #1abc9c;
    font-weight: 400;
  }
  > span {
    line-height: 14px;
    color: #8c8c8c;
    cursor: pointer;
  }
}
.home-footer-info {
  background: #fff;
  padding: 0 0 40px;
  .statistics-chart-body {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    .statistics-chart {
      width: 800px;
      background: #ffffff;
      .statistics-chart-title {
        display: flex;
        align-items: center;
        height: 56px;
        padding: 0 16px;
        border-bottom: 1px solid #f0f0f0;
      }
    }
    .home-footer-feedback {
      flex: 1;
      margin-left: 24px;
      .feedback-body {
        margin-top: 40px;
        background: #ffffff;
        .feedback-title {
          display: flex;
          align-items: center;
          height: 56px;
          padding: 0 16px;
          border-bottom: 1px solid #f0f0f0;
        }
        > div {
          padding: 24px;
          border: 1px solid #f0f0f0;
          > p {
            font-size: 14px;
            line-height: 14px;
            margin-bottom: 24px;
          }
          > input {
            width: 100%;
            height: 32px;
            border: 1px solid #d9d9d9;
            border-radius: 2px;
            margin-bottom: 24px;
          }
          > textarea {
            width: 100%;
            height: 160px;
            border: 1px solid #d9d9d9;
            border-radius: 2px;
          }
          > button {
            margin-top: 24px;
          }
        }
      }
    }
  }
}
</style>
